<template>
    <div class="onboarding-container">
        <div
            class="text-center p-1"
            style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 32px !important;
            "
        >
            <h3 style="font-weight: 800; font-size: 20px; margin-bottom: 16px" class="text-heading">
                Welcome to MemoryShare's Tribute Video Creator
            </h3>
            <p
                style="max-width: 600px; font-size: 16px; line-height: 22px; margin-bottom: 32px"
                class="text-body-light"
            >
                MemoryShare uses AI to create Tribute Videos. Download our mobile app to scan photos and collect stories
                from family members. Once the photos are collected, choose a template, choose the music, and the video
                will be created. MemoryShare is different from other tribute video creators because we encourage family
                members to share their memories of
                {{ service.firstName + ' ' + service.lastName }}.
            </p>

            <button @click="initOnboard" class="btn-blue">Let's Get Started</button>
        </div>
    </div>
</template>
<script>
import initApiServices from '@/services/ApiInitializer';
import { mapActions } from 'pinia';
import { useTributeVideoStore } from '../../stores/tributeVideo';
import { useGlobalState } from '@/stores/globalState';

export default {
    setup() {
        return {
            tributeVideo: useTributeVideoStore(),
        }
    },
    data() {
        return {
            token: '',
            apiService: null,
        };
    },
    props: {
        service: {
            type: Object,
            required: true,
        },
    },
    computed: {
        tributeVideo() {
            return this.tributeVideo;
        },
    },
    methods: {
        ...mapActions(useGlobalState, ['showSnackbar', 'block']),
        async initOnboard() {
            this.block(true);
            try {
                if (!this.tributeVideo.id) {
                    if (!this.apiService) {
                        this.apiService = initApiServices(this.token);
                    }

                    const tributeResp = await this.apiService.tributeVideo.createTributeVideoByService(
                        this.service?.slug,
                        {},
                    );

                    if (!tributeResp.data.eventId) {
                        throw new Error('Error creating  tribute video');
                    }
                }

                if (this.service.slug) {
                    this.$router.push(`/tribute/${this.service.slug}`);
                }
            } catch (error) {
                console.log(error, 'error creating tribute');
            } finally {
                this.block(false);
            }
        },
    },
    mounted() {
        this.$auth.getIdTokenClaims().then(async result => {
            // Get Api Token
            this.token = result.__raw;
            this.apiService = initApiServices(this.token);
        });

        // if (this.tributeVideo.mainPhotoId || this.tributeVideo.deeplink) {
        //     this.windowIndex = 1;
        //     this.stepIndex = 3;

        //     if (this.tributeVideoDeadline) {
        //         this.tributeDeadline = this.tributeVideo.deadline;
        //     }
        // }
    },
};
</script>
<style lang="scss" scoped></style>
